import React from 'react';
import { Sorting } from 'src/types/Sorting';
import { ColumnProps, SortOrder } from 'antd/lib/table';
import { Switch } from 'src/components/common/Switch';
import { ConfigureClientSitesTableInfo } from 'src/types/ConfigureClientSitesTableInfo';

import styles from '../ConfigurationClientSites.module.less';

interface ColumnConfig extends ColumnProps<any> {
  customColRenderer?: (dataIndex: ConfigureClientSitesTableInfo) => React.ReactNode;
}

const sortOrder = (
  sortedInfo: Sorting<ConfigureClientSitesTableInfo> | null,
  key: keyof ConfigureClientSitesTableInfo
): SortOrder | boolean => {
  return sortedInfo && sortedInfo.field === key ? sortedInfo.order : false;
};

const statusRender = (record: any, onAction: any) => {
  return (
    <Switch
      key={record?.ID}
      shouldUseState={false}
      checked={record.ownerClientLookup && record.ownerClientLookup.outlierDetectionInclusionFlag}
      onChange={onAction(record)}
    />
  );
};

const regionRender = (record: any, onAction: any) => {
  return (
    <span onClick={onAction(record)} className={styles.region_view_link}>
      View
    </span>
  );
};

const bookmarkRender = (record: any) => {
  return <span>{record.bookmarkCreated ? 'Y' : 'N'}</span>;
};

export const getColumns = (sorting: any, onChangeStatus: any, onRegionView: any) => {
  const columns: ColumnConfig[] = [
    {
      title: 'Site Name',
      key: 'name',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: record => <span>{record.name}</span>,
      sortOrder: sortOrder(sorting, 'name'),
      sorter: true,
      width: 100,
    },
    {
      title: 'Site ID',
      key: 'ID',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: record => <span>{record.ID}</span>,
      sortOrder: sortOrder(sorting, 'ID'),
      sorter: true,
      width: 100,
    },
    {
      title: 'Data Source',
      key: 'dataSource',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: record => <span>{record.dataSource}</span>,
      sortOrder: sortOrder(sorting, 'dataSource'),
      sorter: true,
      width: 100,
    },
    {
      title: 'Product Type',
      key: 'productType',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: record => <span>{record.productType}</span>,
      sortOrder: sortOrder(sorting, 'productType'),
      sorter: true,
      width: 100,
    },
    {
      title: 'Bookmark Created',
      key: 'bookmarkCreated',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: record => bookmarkRender(record),
      sortOrder: sortOrder(sorting, 'bookmarkCreated'),
      sorter: true,
      width: 120,
    },
    {
      title: 'Regions',
      key: 'region',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: record => regionRender(record, onRegionView),
      sortOrder: sortOrder(sorting, 'region'),
      sorter: true,
      width: 120,
    },
    {
      title: 'Outlier Enabled',
      key: 'outlierdetectioninclusionflag',
      defaultSortOrder: 'ascend',
      className: styles.xCenterColumn,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: record => statusRender(record, onChangeStatus),
      sortOrder: sortOrder(sorting, 'outlierdetectioninclusionflag'),
      sorter: true,
      width: 120,
    },
  ];

  return columns;
};
